var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideHeader)?_c('div',{class:[
    'border-0 d-flex align-items-center bg-transparent',
    {
      'mb-3': _vm.marginBottom
    }
  ]},[(!_vm.hideIcon && _vm.icon)?_c('i',{class:("fa fa-fw " + _vm.icon + " mr-2")}):_vm._e(),_vm._v(" "),(!_vm.hideTitle)?_c('div',{ref:"title",staticClass:"h6 font-weight-normal text-truncate mb-0 widget-title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-inline-block ml-auto"},[_c('a',{class:[
        'btn btn-sm btn-explore py-0',
        _vm.exploreBtnClass,
        {
          'visibility-hidden': !_vm.explore
        }
      ],attrs:{"href":_vm.exploreLink}},[_c('span',{staticClass:"small",domProps:{"innerHTML":_vm._s(_vm.exploreLabel)}})])]),_vm._v(" "),(_vm.description)?_c('b-tooltip',{attrs:{"target":function () { return _vm.$refs['title']; },"placement":"topright","variant":"flat-peter-river"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }